import { render, staticRenderFns } from "./SysCustomFormForm.vue?vue&type=template&id=d4a1624e"
import script from "./SysCustomFormForm.vue?vue&type=script&lang=js"
export * from "./SysCustomFormForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports